/**
 * Company information used in document headers (DO, AN, BOL).
 * Update these values to match your company details.
 */
const COMPANY_INFO = {
  name: 'JINTONG TRANSPORTATION INC.',
  address: '3191 W TEMPLE AVE SUITE 175',
  cityStateZip: 'POMONA, CA 91768',
  tel: '1-909-707-6243',
  email: 'usdocs@jintong-us.com',
  logo: '/logo.png',   // client/public/logo.png — the PDF side reads
                       // server/assets/logo.png; keep the two the same image.
};

export default COMPANY_INFO;
